// extracted by mini-css-extract-plugin
export default {"label":"SwitchComment_label__4+i0N","control":"SwitchComment_control__Ym7br"};